module.exports = __webpack_public_path__ + "images/emoji/earth_americas.855327c9e50ebbaea746.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/earth_americas.png
// module id = pg50
// module chunks = 14